import { recieveAccounts } from "./reducer";
import { APIClient } from "../../../helpers/api_helper";
const api = new APIClient();

export const loadAccounts = () => async (dispatch, getState) => {

    try {
        const data = await api.get('/api/accounts/get_options/')

        if (data) {
            dispatch(recieveAccounts(data));
        }
    } catch (error) {
        console.error('Unable to load accounts!', error)
    }
};
